var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",class:{
        loading: _vm.state !== _vm.stateOff,
        'min-height': _vm.state === _vm.stateOpaque,
        small: _vm.size === _vm.sizeSmall,
    }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state !== _vm.stateOpaque),expression:"state !== stateOpaque"}]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }